'use strict';

class StickyHandler {
  constructor({
    $element,
    $wrapper = $element,
    bottom = false,
    staySticky = false,
    onStateChange = function() {},
  }) {
    this.$element = $element;
    this.$wrapper = $wrapper;
    this.$prevElement = this.$wrapper.prev();

    if (!this.$element.length) {
      return;
    }

    this.bottom = bottom;
    this.staySticky = staySticky;
    this.onStateChange = onStateChange;

    this.stickyClasses = `sticky sticky-${this.bottom ? 'bottom' : 'top'}`;
    this.fixed = this.$element.hasClass('sticky');

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: this.bottom
        ? '0px'
        : `${this.$element.css('padding-top') || '0px'} 0px 0px 0px`,
      threshold: this.bottom ? 1 : [0, 1],
    });
    this.observedElement = this.bottom
      ? this.$element[0]
      : this.$prevElement[0];
    this.observer.observe(this.observedElement);

    if (this.bottom) {
      this._checkForAutoScroll();
    }

    // listener to hide sticky handler after coming back from modal
    window.addEventListener(
      'hashchange',
      (() => {
        if (this.fixed && !this.staySticky) {
          this.change(false);
        }
      }).bind(this),
      false
    );
  }

  _checkForAutoScroll() {
    /*
      Intersection Observer does not work when user reloads the page after scrolling
      Need to do one time check to see if browser is auto-scrolling
    */
    const checkIfAutoScrolled = (() => {
      if (this.$element.offset().top < window.pageYOffset) {
        this.change(true);
      }
      window.removeEventListener('scroll', checkIfAutoScrolled);
    }).bind(this);
    window.addEventListener('scroll', checkIfAutoScrolled, false);
  }

  onIntersect(entries) {
    entries.forEach(entry => {
      const { intersectionRatio, rootBounds, boundingClientRect } = entry;
      if (!this.bottom && rootBounds.bottom < boundingClientRect.top) {
        this.change(false);
      } else if (intersectionRatio === 0) {
        this.change(!this.bottom);
      } else if (intersectionRatio === 1 && this.bottom) {
        this.change(true);
      } else if (intersectionRatio > 0 && !this.bottom && this.fixed) {
        this.change(false);
      }
    });
  }

  change(shouldBeFixed) {
    if (!this.fixed && shouldBeFixed) {
      this.updateCss(shouldBeFixed);
      this.onStateChange();
      if (this.staySticky) {
        this.observer.unobserve(this.observedElement);
      }
    } else if (this.fixed && !shouldBeFixed) {
      this.updateCss(shouldBeFixed);
      this.onStateChange();
    }
  }

  updateCss(shouldBeFixed) {
    this.fixed = shouldBeFixed;
    if (shouldBeFixed) {
      this.$element.addClass(this.stickyClasses);
    } else {
      this.$element.removeClass(this.stickyClasses);
    }
  }
}

module.exports = StickyHandler;



// WEBPACK FOOTER //
// ./modules/sticky_handler/frontend/index.js